export const DnDTip: React.FC = () => {
  return (
    <div className="text-tiny border border-main rounded-md p-4 bg-select border-l-4">
      Tip: Drag and Drop variables to your prompt
    </div>
  );
};
